/**
 * ヘッダー追従処理
 * 上下スクロールで表示非表示
 */
$(function(){
  DEBUG = false,
  log = function(str){if(DEBUG) console.log(str)}
  let Timer = [], sticky = {header: false}, visible = {header: false}
  //header 固定
  gsap.to(".ly_header", {
    scrollTrigger: {
      trigger: "body",
      start: "top",
      end: "bottom",
      markers: DEBUG,
      onUpdate: self => {
        return;
        log(sticky.header)
        // if(sticky.header === false) return
        clearTimeout(Timer.headerSticky)
        if(self.direction < 0) {
          // 上へスクロール
          if(visible.header === undefined || visible.header !== true) {
            Timer.headerSticky = setTimeout(function(){
              visible.header = true
              $('body').addClass('header-sticky')
              gsap.fromTo(".ly_header",{
                y:"-100%",
              },{
                y:"0%",
                duration: .5,
              })
            },10)
          }
        } else {
          // 下へスクロール
          if(visible.header === undefined || visible.header === true) {
            Timer.headerSticky = setTimeout(function(){
              visible.header = false
              gsap.to(".ly_header",{
                y:"-100%",
                duration: .5,
                onComplete: function(){
                  $('body').addClass('header-sticky')
                }
              })
            },10)
          }
        }
      }
    }
  });
  gsap.to(".ly_header", {
    scrollTrigger: {
      trigger: ".ly_header",
      start: "top",
      end: "bottom+=600 center",
      markers: DEBUG,
      onLeave: () => {
        log('Leave')
        // sticky.header = true
      },
      onLeaveBack: () => {
        if(sticky.header === false) return;
        log('Leave back')
        // sticky.header = false
        clearTimeout(Timer.headerSticky)
        $('body').removeClass('header-sticky')
      },
    }
  });
})

if(null !== document.querySelector(".ly_hero.splide")) {
  new Splide(".ly_hero.splide", {
    type: 'loop',
    focus  : 'center',
    rewind: false, // 最後に到達した後、最初に戻る
    perPage: 1, // 表示するスライド枚数
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    cover: false,
    arrows: false,
    pagination: true,
    padding: '10%',
    mediaQuery: 'min',
    speed: 1000,
    interval: 5000,
    breakpoints: {
      750: {
        type   : 'loop',
        focus  : 'center',
        perPage: 3,
        padding: '10%',
      },
    },
  }).mount();
}

function splide_progress($this, splide, newIndex) {
  var calc = ( (newIndex + 1) / (splide.length) ) * 100;
  console.log($this, newIndex, splide, calc);
  var $parent = $($this).parent();
  $parent.find('.splide-progress')
  .css('background-size', calc + '% 100%')
  .attr('aria-valuenow', calc );
  $parent.find( '.slider__label' ).text( calc + '% completed' );
}
function sp($this, args, progressbar) {
  const splide = new Splide($this, args);
  splide.on('mounted', function(){
    if(progressbar !== undefined && progressbar !== false) {
      $($this).after('<div class="splide-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span class="slider__label sr-only"></span></div>');

      // let initial = (splide.length - splide.r.length);
      let initial = splide.index;
      if(splide.options.start !== undefined) initial = splide.options.start;
      if(!splide.Components.Layout.isOverflow()) initial = splide.length; // はみ出しがなければ固定値（常に100％）
      console.log({
        length: splide.length,
        index: splide.index,
        initial: initial,
        perMove: splide.options.perMove, perPage: splide.options.perPage,
        n : splide.length / splide.options.perPage
      });

      splide_progress($this, splide, initial);
    }
  });
  splide.mount();
  // プログレスバー追加
  if(progressbar !== undefined && progressbar !== false) {
    // console.log(splide, splide.length, splide.r.length, splide.index);
    let initial = splide.options.start;
    if(splide.options.start === undefined) initial = 0;
    // splide_progress($this, splide, splide.index);
    splide.on('move', function(newIndex){
      splide_progress($this, splide, newIndex);
    });
  }
}
if(null !== document.querySelector(".bl_showcase.splide")) {
  const list = document.querySelectorAll(".bl_showcase.splide");
  const arr = [...list]; // converts NodeList to Array

  for ( var i = 0; i < arr.length; i++ ) {
    if($(arr[ i ]).hasClass('bl_showcase__category')) {
      sp(arr[ i ], {
        type: 'slide',
        rewind: false, // 最後に到達した後、最初に戻る
        focus     : 'center',
        // autoHeight: true,
        perPage: 1, // 表示するスライド枚数
        perMove: 1, // perPageと同値が良さげ。ページングやArrowの押下時にスライドする枚数。
        arrows: false,
        pagination: false,
        padding: '10%',
        mediaQuery: 'min',
        breakpoints: {
          750: {
            mediaQuery: 'min',
            type   : 'slide',
            focus     : 'center',
            // focus  : 2,
            // clones: 5,
            perPage: 4,
            perMove: 4,
            padding: '0%',
          },
        },
      }, true);
    } else if($(arr[ i ]).hasClass('bl_showcase__feature')) {
      sp(arr[ i ], {
        type: 'slide',
        rewind: true, // 最後に到達した後、最初に戻る
        focus     : 'center',
        // autoHeight: true,
        perPage: 1, // 表示するスライド枚数
        perMove: 1, // perPageと同値が良さげ。ページングやArrowの押下時にスライドする枚数。
        arrows: false,
        pagination: false,
        padding: '10%',
        mediaQuery: 'min',
        breakpoints: {
          750: {
            mediaQuery: 'min',
            type   : 'slide',
            focus  : false,
            // focus  : 2,
            clones: 5,
            perPage: 4,
            perMove: 1,
            padding: '0%',
            // rewind: true,
            autoWidth: true,
          },
        },
      }, true);
    } else {
      sp(arr[ i ], {
        type: 'loop',
        rewind: true, // 最後に到達した後、最初に戻る
        //focus     : 'center',
        // autoHeight: true,
        perPage: 2, // 表示するスライド枚数
        perMove: 1, // perPageと同値が良さげ。ページングやArrowの押下時にスライドする枚数。
        arrows: true,
        pagination: false,
        padding: '10%',
        autoplay: 'pause',
        autoScroll: {
          speed: 1,
        },
        intersection: {
          inView: {
            autoplay: true,
            autoScroll: false,
          },
          outView: {
            autoplay: false,
            autoScroll: false,
          },
        },
        mediaQuery: 'min',
        breakpoints: {
          750: {
            mediaQuery: 'min',
            type   : 'loop',
            focus  : false,
            // focus  : 2,
            // clones: 5,
            perPage: 6,
            perMove: 1,
            padding: '0%',
            // rewind: true,
            autoplay: 'pause',
            intersection: {
              inView: {
                autoplay: true,
                autoScroll: false,
              },
              outView: {
                autoplay: false,
                autoScroll: false,
              },
            },
          },
        },
      });
    }
  
  }
}
